export enum HeaderMenuIconButtonPositionsGroup {
  Search = 'search',
  User = 'user',
  Cart = 'cart',
}
